import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Features from "./components/Features/Features";
import Pricing from "./components/Pricing/Pricing";
import Testimonial from "./assets/Testimonial/Testimonial";
import CTA from "./components/CTA/CTA";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

const PrivacyPolicy = lazy(() => import("./components/Legals/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("./components/Legals/RefundPolicy"));
const TermsAndConditions = lazy(() => import("./components/Legals/TermsAndConditions"));
const DataUsageDeletion = lazy(() => import("./components/Legals/DataUsageDeletion"));
const Enterprise = lazy(() => import("./pages/EnterPrise"));

const Faqs = lazy(() => import("./components/Faqs/Faqs"));
const AdminApp = lazy(() => import("./admin/AdminApp"));
const ProfileRedirect = lazy(() => import("./pages/ProfileRedirect"));

function RouteAnalytics() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}

function Home() {
  return (
    <div id="top">
      <main>
        <Header />
        <Hero />
        <Pricing />
        <Features />
        <Testimonial />
        <Suspense fallback={<div style={{ minHeight: "200px" }}></div>}>
          <Faqs />
        </Suspense>
        <CTA />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <RouteAnalytics />

      {/* ✅ scroll to top whenever route changes */}
      <ScrollToTop />

      <Suspense fallback={<div style={{ minHeight: "100vh" }}>Loading...</div>}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/enterprise" element={<Enterprise />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route
          path="/privacy"
          element={
            <>
              <Header />
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="/data-usage"
          element={
            <>
              <Header />
              <DataUsageDeletion />
              <Footer />
            </>
          }
        />
        <Route
          path="/refund"
          element={
            <>
              <Header />
              <RefundPolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="/terms"
          element={
            <>
              <Header />
              <TermsAndConditions />
              <Footer />
            </>
          }
        />
        {/* Short profile link: /<username> -> the backend-rendered /u/<username> card.
            Registered last. React Router ranks static segments above dynamic ones, so this
            cannot steal /privacy, /terms, /enterprise or /admin/* regardless of order. */}
        <Route path=":username" element={<ProfileRedirect />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
